import { Tracking } from '@gjensidige/core-analytics';

import { ScenarioStep, StepType } from './types/enums';
import { ProcessGuideTrackingOptions } from './types/index';

const TRACKER_DEFAULT_OPTIONS = {
  application_name: 'huskeliste_borettslag',
  application_module: 'huskeliste_borettslag',
  application_partner: 'gjensidige',
  customer_segment: 'naringsliv',
  business_area: 'forsikring',
  scenario_name: 'huskeliste',
  scenario_step: ScenarioStep.START
};

class Tracker {
  tracking: Tracking;

  constructor() {
    this.tracking = new Tracking(TRACKER_DEFAULT_OPTIONS);
  }

  init() {
    // This is needed because Enonic CMS overrides it
    this.setOptions({
      customer_segment: 'næringsliv',
      application_name: 'huskeliste_borettslag'
    });
  }

  getOptions() {
    return this.tracking.options;
  }

  setOptions = (
    additionalOptions: Partial<ProcessGuideTrackingOptions> //TODO move this into FQ
  ) => {
    const options = {
      ...this.tracking.options,
      ...additionalOptions
    };

    this.tracking.setOptions(options);
  };

  onScenarioStepChange = (scenarioStep: StepType) => {
    this.setOptions({
      scenario_step: scenarioStep,
      page_pathname: `${location.pathname}/${
        this.getOptions().application_name
      }/${this.getOptions().application_module}/${
        this.getOptions().scenario_name
      }/${scenarioStep}`
    });
    this.tracking.trackView();
  };
}

const tracker = new Tracker();
export default tracker;
